import { render, staticRenderFns } from "./DesmatamentoParaguaiVega2025.vue?vue&type=template&id=5f389e46&scoped=true&lang=pug"
import script from "./DesmatamentoParaguaiVega2025.vue?vue&type=script&lang=js"
export * from "./DesmatamentoParaguaiVega2025.vue?vue&type=script&lang=js"
import style0 from "./DesmatamentoParaguaiVega2025.vue?vue&type=style&index=0&id=5f389e46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f389e46",
  null
  
)

export default component.exports